export function showErrorMessage (input: HTMLInputElement | HTMLSelectElement, message: string) {
    if (input.closest('.hidden') === null) {
        input.setCustomValidity(message);
        input.classList.add('error');
        // don't immediately show the user an error message
        // input.reportValidity();
    } else {
        hideErrorMessage(input)
        input.classList.remove('error')
    }
}

export function hideErrorMessage (input: HTMLInputElement | HTMLSelectElement) {
    input.setCustomValidity('')
    input.classList.remove('error')
}